// shopSections.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_SHOP_SECTION_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Shop sections.
 * @module reducer/shopSections
 */
const shopSections = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_SHOP_SECTION_DATA:
      return _MERGE_SHOP_SECTION_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge shop section data
 * @kind reducer/actionType
 * @name MERGE_SHOP_SECTION_DATA
 * @param {object} payload - payload
 * @param {array} payload.selectPath - select path
 * @param {any} payload.data - data
 * @return {Immutable.Map} New state
 */
const _MERGE_SHOP_SECTION_DATA = payload => state => {
  return state.mergeDeepIn(payload.selectPath, payload.data);
};

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default shopSections;
